<template>
    <div class="drawer">
        <div
            class="wrapper"
            :style="{
                transform: drawerOpened ? 'translateX(0)' : 'translateX(100%)',
            }"
        >
            <div class="container">
                <div class="close-icon" @click="toggleDrawer()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                        <path
                            fill="none"
                            stroke="#8999b1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="4"
                            d="M2 30L30 2m0 28L2 2"
                        ></path>
                    </svg>
                </div>

                <div class="logo">
                    <router-link to="/">
                        <img
                            v-lazy="
                                this.resizeImage(
                                    this.$globalConstants.host
                                        .header_banner_dark ||
                                        this.$globalConstants.host
                                            .header_banner,
                                    260,
                                    60,
                                    100
                                )
                            "
                            :width="180"
                            :height="40"
                            alt="logo"
                        />
                    </router-link>
                </div>

                <div class="bottom__menu">
                    <ul class="nav__list">
                        <li
                            class="nav__item"
                            v-for="item in navItems"
                            :key="item.id"
                        >
                            <p v-if="item.dropdown_items" class="nav__link">
                                <router-link :to="fullPath(item.route)">
                                    <span @click="toggleDrawer()">{{
                                        $t(item.name)
                                    }}</span>
                                </router-link>

                                <svg
                                    @click="toggleDropdown($event)"
                                    aria-hidden="true"
                                    class="chevron"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="chevron-down"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                                    ></path>
                                </svg>
                            </p>

                            <router-link
                                v-else
                                class="nav__link"
                                :to="fullPath(item.route)"
                            >
                                <span>{{ $t(item.name) }}</span>
                            </router-link>

                            <ul
                                class="nav__list-child"
                                v-if="item.dropdown_items"
                            >
                                <li
                                    class="nav__item-child"
                                    v-for="item in item.dropdown_items"
                                    :key="item.id"
                                    @click="
                                        toggleDrawer();
                                        toggleDropdown($event);
                                    "
                                >
                                    <router-link
                                        class="nav__link-child"
                                        :to="fullPath(item.route)"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 1024 1024"
                                            :style="[
                                                isRtlLanguageFunc(
                                                    $globalConstants.host
                                                        .language_code,
                                                    {
                                                        transform:
                                                            'scale(-1, 1)',
                                                    }
                                                ),
                                            ]"
                                        >
                                            <path
                                                fill="#246aa8"
                                                d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512c282.784 0 512-229.216 512-512C1024 229.232 794.784 0 512 0m0 961.008c-247.024 0-448-201.984-448-449.01c0-247.024 200.976-448 448-448s448 200.977 448 448s-200.976 449.01-448 449.01m20.368-642.368c-12.496 12.496-12.496 32.752 0 45.248l115.76 115.76H287.68c-17.68 0-32 14.336-32 32s14.32 32 32 32h362.464l-117.76 117.744c-12.496 12.496-12.496 32.752 0 45.248c6.256 6.256 14.432 9.376 22.624 9.376s16.368-3.12 22.624-9.376l189.008-194l-189.008-194c-12.512-12.496-32.752-12.496-45.264 0"
                                            ></path>
                                        </svg>
                                        {{ $t(item.name) }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="drawerOpened" @click="toggleDrawer()" class="overlay"></div>
    </div>
</template>

<script>
import { helper, contentDirectionMixin } from '@/ghost-mixins';

export default {
    name: 'DrawerMenu',
    mixins: [helper, contentDirectionMixin],
    props: {
        navItems: {
            type: Array,
            required: true,
        },
        drawerOpened: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        toggleDrawer() {
            this.$emit('drawerToggled', !this.drawerOpened);
        },
        toggleDropdown(e) {
            e.target.closest('.nav__item').classList.toggle('__opened');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.drawer {
    .wrapper {
        position: fixed;
        z-index: 100;
        top: 0;
        min-width: 280px;
        width: 70vw;
        height: 100%;
        background: #fff;
        transition: transform 0.5s ease;
        max-height: 100vh;
        overflow-y: auto;
        right: 0;

        .container {
            height: 100%;
            margin: auto;
            max-width: 1180px;
            display: flex;
            flex-direction: column;

            .logo {
                height: 52px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: var(--drawer-background-color);

                img {
                    object-fit: contain;
                    max-height: 42px;
                    width: auto;
                    max-width: 160px;
                }
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                width: 16px;
                cursor: pointer;
            }

            .bottom__menu {
                display: flex;
                align-items: center;
                padding-top: 17px;
                padding-inline-start: 20px;
                padding-inline-end: 20px;
                .nav__list {
                    display: flex;
                    flex-direction: column;
                    list-style: none;
                    padding: 0;
                    margin: 0 0 20px 0;
                    width: 100%;

                    .nav__item {
                        border-bottom: 1px solid #e7eaee;

                        .nav__link {
                            padding: 14px 0;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 3px;
                            color: #333333;
                            cursor: pointer;
                            text-decoration: none;

                            .chevron {
                                width: 12px;
                                color: #333333;
                            }
                        }

                        &.__opened .nav__list-child {
                            display: block;
                        }

                        &.__opened .nav__link .chevron {
                            transform: rotate(180deg);
                        }

                        .nav__list-child {
                            list-style-type: none;
                            display: none;

                            .nav__item-child {
                                border-top: 1px solid #e7eaee;

                                .nav__link-child {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-start;
                                    gap: 10px;
                                    padding-top: 10px;
                                    padding-bottom: 10px;
                                    padding-inline-end: 16px;
                                    padding-inline-start: 0px;
                                    font-weight: 400;
                                    font-size: 14px;
                                    line-height: 17px;
                                    color: #333333;

                                    svg {
                                        min-width: 20px;
                                        path {
                                            fill: var(--dropdown-icon-color);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.overlay {
    content: '';
    z-index: 10;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
}
</style>
